/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Railexpand1Inputs */

const en_railexpand1 = /** @type {(inputs: Railexpand1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand menu`)
};

const de_railexpand1 = /** @type {(inputs: Railexpand1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü ausklappen`)
};

/**
* | output |
* | --- |
* | "Expand menu" |
*
* @param {Railexpand1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const railexpand1 = /** @type {((inputs?: Railexpand1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Railexpand1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_railexpand1(inputs)
	return de_railexpand1(inputs)
});
export { railexpand1 as "railExpand" }